var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path366",
    d: "M0-682.665H28v28H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42430",
    "data-name": "Group 42430",
    transform: "translate(-189 7918)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15940",
    "data-name": "Rectangle 15940",
    width: 32,
    height: 32,
    transform: "translate(189 -7918)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g360",
    transform: "translate(191 -7916)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g362"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g364",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g374",
    transform: "translate(8.728 6.971)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path376",
    d: "M-246.524-123.26a5.272,5.272,0,0,1-5.272,5.272,5.272,5.272,0,0,1-5.272-5.272,5.272,5.272,0,0,1,5.272-5.272A5.272,5.272,0,0,1-246.524-123.26Z",
    transform: "translate(257.067 128.532)",
    fill: "none",
    stroke: "#d1131d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g378",
    transform: "translate(6.137 17.515)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path380",
    d: "M0-165.147a7.909,7.909,0,0,1,7.863-7.063,7.909,7.909,0,0,1,7.863,7.063",
    transform: "translate(0 172.21)",
    fill: "none",
    stroke: "#d1131d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g370",
    transform: "translate(0.82 0.82)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path372",
    d: "M-616.306-308.153a13.18,13.18,0,0,1-13.18,13.18,13.18,13.18,0,0,1-13.18-13.18,13.18,13.18,0,0,1,13.18-13.18A13.18,13.18,0,0,1-616.306-308.153Z",
    transform: "translate(642.665 321.333)",
    fill: "none",
    stroke: "#1564e8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircle);
export default __webpack_public_path__ + "static/media/user-circle.17167cf81108d113c354ec39da1e3c4e.svg";
export { ForwardRef as ReactComponent };